export default __webpack_public_path__ + "static/media/stonehide.be831cb0.png";